<template>
  <div class="text-center z5">
    <v-card width="1400">
      <v-row v-if="!loading" no-gutters>
        <v-col cols="12">
          <v-divider />
          <v-card-text class="pa-0">
            <v-row no-gutters>
              <v-col cols="12">
                <ResourceHorseListHeader :headers="headers" />
                <div style="height:544px;" class="overflow-y-auto d-flex flex-column redScroll">
                  <!-- content -->
                  <div
                    v-for="(value, index) in instructorHorseList"
                    :key="`instructor_horse_list_${index}`"
                    class="horseList"
                  >
                    <div v-if="value.instructorName || (!value.instructor && value.horse)" class="d-flex align-center">
                      <v-col cols="6" class="d-flex align-center justify-center">
                        <div v-if="value.instructorName" class="d-flex col-12 justify-space-between align-center">
                          <span
                            :draggable="!computedSession.cancelled && canUserPerformAction"
                            class="d-flex align-center col-10 grab"
                            @dragstart="dragStartPickers($event, value.instructor, 'instructor', index)"
                            @drop="drop($event, value.instructor, 'instructor', index)"
                            @dragover.prevent
                          >
                            {{ value.instructorName }}
                          </span>
                          <v-btn v-if="canUserPerformAction" class="d-flex align-center" icon :disabled="!canUserPerformAction" @click="handleDelete(index, 'instructor')">
                            <v-icon color="black">
                              mdi-minus-circle-outline
                            </v-icon>
                          </v-btn>
                        </div>
                        <ContentPicker
                          v-else
                          v-model="instructorHorseList[index].instructor"
                          :is-modal-open="assignInstructorModalOpen"
                          :items="notSelectedInstructors"
                          :is-single-select="true"
                          wtype="instructor"
                          :headers="instructorTableHeaders"
                          :item="value"
                          @modalChangeState="modalChangeState"
                          @confirmSelection="confirmSelection"
                        >
                          <template #trigger>
                            <div
                              class="col-12"
                              :draggable="!computedSession.cancelled && canUserPerformAction"
                              @dragstart="dragStartPickers($event, '', 'instructor', index)"
                              @drop="drop($event, '', 'instructor', index)"
                              @dragover.prevent
                            >
                              <v-icon size="24" color="third" right @click.prevent="openSelectedInstructorModal(true, index)">mdi-account-plus</v-icon>
                            </div>
                          </template>
                        </ContentPicker>
                      </v-col>
                      <v-col
                        v-if="isEquestrianSession"
                        cols="1"
                        class="text-center"
                      >
                        <v-icon
                          color="black"
                        >
                          mdi-code-tags
                        </v-icon>
                      </v-col>
                      <v-col cols="5">
                        <div v-if="value.horse" class="d-flex col-12 justify-space-between align-center">
                          <span
                            class="d-flex align-center col-10 grab"
                            :draggable="!computedSession.cancelled && canUserPerformAction"
                            @dragstart="dragStartPickers($event, value.horse, 'horse', index)"
                            @drop="drop($event, value.horse, 'horse', index)"
                            @dragover.prevent
                          >
                            {{ getHorseName(value.horse) }}
                          </span>
                          <v-btn v-if="canUserPerformAction" icon :disabled="!canUserPerformAction" @click="handleDelete(index, 'horse')">
                            <v-icon color="black">
                              mdi-minus-circle-outline
                            </v-icon>
                          </v-btn>
                        </div>
                        <ContentPicker
                          v-else-if="isEquestrianSession"
                          v-model="instructorHorseList[index].horse"
                          :is-modal-open="assignHorsesModalOpen"
                          :items="notSelectedHorses"
                          :is-single-select="true"
                          wtype="horse"
                          :headers="horsesTableHeaders"
                          :item="value"
                          :is-horse="true"
                          @modalChangeState="modalChangeState"
                          @confirmSelection="confirmSelection"
                        >
                          <template #trigger>
                            <div
                              class="col-12"
                              :draggable="!computedSession.cancelled && canUserPerformAction"
                              @dragstart="dragStartPickers($event, '', 'horse', index)"
                              @drop="drop($event, '', 'horse', index)"
                              @dragover.prevent
                            >
                              <v-icon size="24" color="third" right @click="openSelectedHorsesModal(true, index)">mdi-plus</v-icon>
                            </div>
                          </template>
                        </ContentPicker>
                      </v-col>
                    </div>
                    <v-divider />
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>
              <v-container>
                <v-col cols="12" class="d-inline-block py-0 padding-12">
                  <!-- extract to component table footer ? -->
                  <v-col :cols="isEquestrianSession ? 5 : 12" class="d-inline-block">
                    <ContentPicker
                      v-model="selectedInstructors"
                      :is-modal-open="isInstructorModalOpen"
                      :items="notSelectedInstructors"
                      :is-single-select="false"
                      wtype="instructor"
                      :headers="instructorTableHeaders"
                      @modalChangeState="modalChangeState"
                      @confirmSelection="confirmSelection"
                    >
                      <template #trigger>
                        <v-btn
                          color="third"
                          outlined
                          large
                          rounded
                          class="font-weight-bold my-3"
                          @click="openSelectedInstructorModal(false)"
                        >
                          Ajouter un Instructeur
                          <v-icon size="24" color="third" right>mdi-account-plus</v-icon>
                        </v-btn>
                      </template>
                    </ContentPicker>
                  </v-col>
                  <v-col v-if="isEquestrianSession" cols="2" class="d-inline-block" />
                  <v-col v-if="isEquestrianSession" cols="5" class="d-inline-block">
                    <ContentPicker
                      v-model="selectedHorses"
                      :is-modal-open="isHorsesModalOpen"
                      :items="notSelectedHorses"
                      :is-single-select="false"
                      wtype="horse"
                      :headers="horsesTableHeaders"
                      :is-horse="true"
                      @modalChangeState="modalChangeState"
                      @confirmSelection="confirmSelection"
                    >
                      <template #trigger>
                        <v-btn
                          color="third"
                          outlined
                          large
                          rounded
                          class="font-weight-bold my-3"
                          @click="openSelectedHorsesModal(false)"
                        >
                          Ajouter un cheval
                          <v-icon size="24" color="third" right>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                    </ContentPicker>
                  </v-col>
                  <!-- end extract to component -->
                </v-col>
              </v-container>
            </v-row>
          </v-card-text>
        </v-col>
        <SessionEditOverlay
          v-if="session.recurring && showConfirmationModal"
          :activator.sync="showConfirmationModal"
          :change-confirmation-modal="changeEditSessionOverlay"
          :change-recurring-session="manageContents"
          :options="editOverlayOptions"
          :typeOfAction="typeOfAction"
          :contentType="updateParams.contentType"
        />
      </v-row>
      <div v-else class="d-flex justify-center align-center full-height min-height350">
        <Loader />
      </div>
    </v-card>
  </div>
</template>

<script>
import { ref, watch, computed, onBeforeMount, provide } from '@vue/composition-api';

import store from '@/store';
import { availableHorses, filterHorse } from '@/helpers/dataManager';
import { sendNotification, sortArray, dragStartPickers, dropPickers, deleteOptions, stageRadioOptions } from '../../helpers/utils';
import { updateSessionAmplify, addInstructorsToSession, addHorsesToSession, deleteContentsFromSession } from '../../helpers/amplify';
import { sessionsWithPeriods, getSessionFieldByWtype, equestrianSession, recurringHorseAssignSessions } from '@/helpers/sessions';

import SessionEditOverlay from '@/components/sessions/createForm/SessionEditOverlay.vue';
import ResourceHorseListHeader from '../resourceHorseList/ResourceHorseListHeader.vue';
import ContentPicker from './ContentPicker.vue';
import Loader from '@/components/common/Loader.vue';

export default {
  components: {
    ResourceHorseListHeader,
    ContentPicker,
    Loader,
    SessionEditOverlay
  },
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    /* Single Selection */
    const assignInstructorModalOpen = ref(false);
    const assignHorsesModalOpen = ref(false);

    /* Multiple Selection */
    const isInstructorModalOpen = ref(false);
    const isHorsesModalOpen = ref(false);
    const selectedInstructors = ref([]);
    const selectedHorses = ref([]);
    const selectedLevels = ref([]);

    const selectedIndex = ref(null);

    const horsesWithoutInstructor = ref(null);
    const horseTypes = ref([]);

    const typeOfUpdate = ref('SINGLE');

    const typeOfAction = ref(null);
    const updateParams = ref({});
    const deleteParams = ref({});

    const showConfirmationModal = ref(false);

    const isEquestrianSession = computed(() => equestrianSession(props.session.type));

    const canAssignHorsesRecurring = computed(() => recurringHorseAssignSessions.includes(props.session.type));

    const changeEditSessionOverlay = value => {
      showConfirmationModal.value = value;
    };

    const editOverlayOptions = computed(() => {
      if (sessionsWithPeriods.includes(props.session.type)) {
        return stageRadioOptions;
      }
      return deleteOptions;
    });

    const instructorHorseList = ref([]);
    const loading = ref(false);

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    const getInstructorDetail = uuid => store.getters.instructor(uuid);
    const getHorsedetail = uuid => store.getters.horse(uuid);
    const getHorseName = uuid => getHorsedetail(uuid)?.horse_name;

    const instructorTableHeaders = [
      { text: 'Nom', value: 'label', sortable: false }
    ];
    const horsesTableHeaders = [
      { text: 'Nom', value: 'label', align: 'center', sortable: false },
      { text: 'Effort quotidien', value: 'dailyEffort', align: 'center', sortable: true },
      { text: 'Effort hebdomadaire', value: 'weeklyEffort', align: 'center', sortable: true }
    ];

    const sessions = computed(() => store.getters.dailySessions);

    const computedSession = computed(() => {
      if (props.session) {
        const sessionBody = { ...sessions.value.find(s => s.uuid === props.session.uuid) };
        if (sessionBody && !sessionBody.horses) {
          sessionBody.horses = [];
        }
        if (sessionBody && !sessionBody.instructors) {
          sessionBody.instructors = [];
        }
        return sessionBody;
      }
      return null;
    });

    const instructorsAmount = computed(() => (computedSession.value?.instructors || []).filter(i => getInstructorDetail(i.uuid)).length);

    const instructorsHorsesAmount = computed(() => (computedSession.value?.horses || []).filter(horse => horse.isInstructorHorse).length);

    const headers = computed(() => {
      if(isEquestrianSession.value) {
        return [
          { label: 'Instructeurs', icon: 'mdi-horse-human', canShow: true, showCounter: true, counter: instructorsAmount.value, cols: 6 },
          { isDivider: true, canShow: true, cols: 1 },
          { label: 'Chevaux', icon: 'mdi-horse', canShow: true, showCounter: true, counter: instructorsHorsesAmount.value, cols: 5 }
        ];
      }
      return [
        { label: 'Instructeurs', icon: 'mdi-account-outline', canShow: true, showCounter: true, counter: instructorsAmount.value, cols: 6 }
      ];
    });

    const instructors = computed(() => (store.state.instructors || []).map(item => ({
      uuid: item.uuid,
      label: item.fullname
    })));

    const getAvailableHorses = computed(() => {
      const availableHorsesForSession = availableHorses(computedSession.value, true, false, true);

      return filterHorse(availableHorsesForSession, horsesWithoutInstructor.value, computedSession.value, horseTypes.value, 'participants', selectedLevels.value)
        .map(horse => ({ uuid: horse.uuid, wtitle: horse.horse_name, label: horse.horse_name, dailyEffort: horse.dailyEffort, weeklyEffort: horse.weeklyEffort, maxHoursEffort: horse.maxHoursEffort }));
    });

    const notSelectedHorses = computed(() => (getAvailableHorses.value || []).filter(horse => !(computedSession.value.horses || []).some(h => h.uuid === horse.uuid && !h.isInstructorHorse)));

    const notSelectedInstructors = computed(() => (instructors.value || []).filter(instructor => !(computedSession.value.instructors || []).some(i => instructor.uuid === i.uuid)));

    const horseAssignRecurringAutoAction = computed(() => store.state.autoActionFlags.horseAssignRecurring);

    const resetValues = () => {
      instructorHorseList.value = [];
      selectedInstructors.value = [];
      selectedHorses.value = [];

      (computedSession.value.horses || []).filter(horse => horse.isInstructorHorse).map(h => {
        instructorHorseList.value.push({
          horse: h.uuid,
          instructor: null
        });
      });
      (computedSession.value.instructors || []).map(i => {
        const instructorDetails = getInstructorDetail(i.uuid);
        const instructor = { ...i, fullname: instructorDetails?.fullname };

        /* If instructor has horse search for it in instructorHorseList and add it in correct position */
        if (instructor.horse) {
          const index = instructorHorseList.value.findIndex(list => list.horse === instructor.horse);
          if (index !== -1) {
            instructorHorseList.value[index].instructor = instructor.uuid;
            instructorHorseList.value[index].instructorName = instructor?.fullname;
            return;
          }
        }
        instructorHorseList.value.push({
          horse: null,
          instructor: instructor.uuid,
          instructorName: instructor?.fullname
        });
      });

      // sort
      instructorHorseList.value = sortArray(instructorHorseList.value, 'instructorName');
    };

    const updateSession = async newSession => {
      loading.value = true;
      await updateSessionAmplify(newSession);
      loading.value = false;
      sendNotification('success', 'Ressource ajoutée avec succès');
    };

    /* Update session based on value from instructorHorseList */
    const updateSessionFields = async () => {
      const newSession = { ...computedSession.value };
      const participantHorses = newSession.horses.filter(h => !h.isInstructorHorse);
      newSession.horses = participantHorses;
      newSession.instructors = [];

      instructorHorseList.value.map(item => {
        if (item.horse) {
          newSession.horses.push({ uuid: item.horse, wtitle: getHorseName(item.horse), isInstructorHorse: true });
        }

        if (item.instructor) {
          newSession.instructors.push({ uuid: item.instructor, horse: item.horse });
        }
      });
      await updateSession(newSession);
    };

    // When its a single select we send the index of the selected row in the listing so we know where to add what we select
    const confirmSingleSelection = (type, selectedItem) => {
      if (selectedIndex.value !== -1) {
        instructorHorseList.value[selectedIndex.value][type] = selectedItem.uuid;
      }
    };

    const confirmMultipleSelection = type => {
      if (type === 'instructor') {
        /* Add selected instructors that dont exist in the list to instructorHorseList */
        selectedInstructors.value.map(instructor => {
          const index = instructorHorseList.value.findIndex(item => item.instructor === instructor.uuid);
          if (index === -1) {
            instructorHorseList.value.push({ instructor: instructor.uuid, horse: null });
          }
        });
        return;
      }
      /* Add selected horses that dont exist in the list  to instructorHorseList */
      selectedHorses.value.map(horse => {
        const index = instructorHorseList.value.findIndex(item => item.horse === horse.uuid);
        if (index === -1) {
          instructorHorseList.value.push({ horse: horse.uuid, instructor: null });
        }
      });
    };

    const addContents = async () => {
      const { contentType, contents, isSingleSelect } = updateParams.value;

      let contentsToAdd = [...contents];

      /* When its single selection its means we are adding in a line where it exists a contenttype already, we need to propagate it */
      if (isSingleSelect && selectedIndex.value !== -1) {
        contentsToAdd = [{ ...instructorHorseList.value[selectedIndex.value], ...contentsToAdd[0] }];
      }

      loading.value = true;

      let response = false;
      switch (contentType) {
        case 'instructor':
          response = await addInstructorsToSession(props.session.id, contentsToAdd, typeOfUpdate.value);

          break;

        default:
          response = await addHorsesToSession(props.session.id, contentsToAdd, typeOfUpdate.value, null, true);
          break;
      }

      if (!response) {
        loading.value = false;
        return;
      }

      if (isSingleSelect) {
        confirmSingleSelection(contentType, contentsToAdd[0]);
      } else {
        confirmMultipleSelection(contentType);
      }

      loading.value = false;

      /* Close all modals */
      assignInstructorModalOpen.value = false;
      assignHorsesModalOpen.value = false;
      isInstructorModalOpen.value = false;
      isHorsesModalOpen.value = false;
      typeOfUpdate.value = 'SINGLE';
      changeEditSessionOverlay(false);
    };

    // When its a single select we send the object from the List to ContentPicker so we know where to add what we select
    const confirmSelection = async ({ type, selectedItems, isSingleSelect }) => {
      updateParams.value = { contentType: type, contents: selectedItems, isSingleSelect };

      const allowedHorsesRecurringUpdate = type === 'horse' ? canAssignHorsesRecurring.value : true;

      if (props.session.recurring && allowedHorsesRecurringUpdate && !horseAssignRecurringAutoAction.value) {
        typeOfAction.value = 'add';
        changeEditSessionOverlay(true);
        return;
      }

      addContents();
    };

    const deleteContents = async () => {
      const { contentType, index } = deleteParams.value;

      loading.value = true;
      const response = await deleteContentsFromSession(props.session, instructorHorseList.value[index][contentType], typeOfUpdate.value, getSessionFieldByWtype(contentType));

      if (!response) {
        loading.value = false;
        return;
      }

      instructorHorseList.value[index][contentType] = null;

      loading.value = false;
    };

    const handleDelete = (index, contentType) => {
      if (!canUserPerformAction.value) {
        return;
      }

      deleteParams.value = { contentType, index };

      if (props.session.recurring) {
        typeOfAction.value = 'delete';
        changeEditSessionOverlay(true);
        return;
      }

      deleteContents();
    };

    const manageContents = () => {
      changeEditSessionOverlay(false);
      if (typeOfAction.value === 'delete') {
        deleteContents();
        return;
      }
      addContents();
    };

    const drop = async (event, dropId, wtype, index) => {
      const { updatedArray, success } = dropPickers(event, dropId, wtype, instructorHorseList.value, computedSession.value, index);
      if (success) {
        instructorHorseList.value = updatedArray;
        await updateSessionFields();
      }
    };

    const modalChangeState = ({ modalValue, type, singleSelect }) => {
      switch (type) {
        case 'instructor':
          if (singleSelect) {
            assignInstructorModalOpen.value = modalValue;
            return;
          }
          isInstructorModalOpen.value = modalValue;
          break;
        case 'horse':
          if (singleSelect) {
            assignHorsesModalOpen.value = modalValue;
            return;
          }
          isHorsesModalOpen.value = modalValue;
          break;

        default:
          break;
      }
    };

    const openSelectedInstructorModal = (isSingle, index) => {
      if (isSingle) {
        assignInstructorModalOpen.value = true;
        selectedIndex.value = index;
        return;
      }
      isInstructorModalOpen.value = true;
    };

    const openSelectedHorsesModal = (isSingle, index) => {
      if (isSingle) {
        assignHorsesModalOpen.value = true;
        selectedIndex.value = index;
        return;
      }
      isHorsesModalOpen.value = true;
    };

    watch(instructorHorseList, newValue => {
      newValue.map((value, index) => {
        // Remove empty objects from array
        if (!value.horse && !value.instructor) {
          newValue.splice(index, 1);
        }
      });
    });

    watch(() => props.session, () => {
      resetValues();
    });

    // hook
    onBeforeMount(async () => {
      loading.value = true;
      if (!store.state.isLazyLoaded.instructors) {
        await store.dispatch('getInstructors');
      }
      if (!store.state.isLazyLoaded.horses) {
        await store.dispatch('getHorses');
      }
      loading.value = false;
      resetValues();
    });

    /* Horses Filter */
    provide('horseWithoutParticipant', horsesWithoutInstructor);
    provide('selectedHorseTypes', horseTypes);
    provide('levelsList', selectedLevels);

    /* Type of session update */
    provide('typeOfupdate', typeOfUpdate);

    return {
      loading,
      confirmSelection,
      computedSession,
      headers,
      isInstructorModalOpen,
      isHorsesModalOpen,
      selectedInstructors,
      modalChangeState,
      instructorTableHeaders,
      horsesTableHeaders,
      openSelectedInstructorModal,
      openSelectedHorsesModal,
      selectedHorses,
      getAvailableHorses,
      instructorHorseList,
      assignHorsesModalOpen,
      assignInstructorModalOpen,
      canUserPerformAction,
      handleDelete,
      dragStartPickers,
      drop,
      notSelectedHorses,
      notSelectedInstructors,
      updateSessionFields,
      getInstructorDetail,
      getHorsedetail,
      getHorseName,
      instructors,
      changeEditSessionOverlay,
      showConfirmationModal,
      editOverlayOptions,
      manageContents,
      isEquestrianSession,
      typeOfAction,
      updateParams
    };
  }
};
</script>

<style>
  .horseList:hover {
    background-color: #f5f4f4;
  }
</style>
